import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { breakWord, formateDate, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";
import * as Role from "../../../services/roles.services";

const RoleView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const params = useParams();
    const [showdefault, setShowDefault] = useState({});
    console.log(showdefault, "showdefault");

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("sidebar_link_roles"), url: "/admin/permission-management/roles/list/1" },
        { title: t("btn_view"), url: "" },
    ];


    useEffect(() => {
        Role
            .Details(params.id)
            .then((data) => {
                setShowDefault(data && data.data ? data.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, []);


    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">{t("view_roles")}</h6>
                            </div>
                            {

                            }
                            {showdefault && Object.keys(showdefault)?.length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table
                                            id="simple-table"
                                            className="table  table-bordered table-hover"
                                        >
                                            <tbody>

                                                <tr>
                                                    <th>{t("label_title")} </th>
                                                    <td className="text-capitalize">
                                                        {showdefault && showdefault?.title
                                                            ? showdefault.title
                                                            : "N/A"}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("label_permissions")}</th>
                                                    <td>
                                                        {Array.isArray(showdefault?.permissionIDs) && showdefault.permissionIDs.length > 0 ? (
                                                            showdefault.permissionIDs.length === 1 ? (
                                                                showdefault.permissionIDs[0].title
                                                            ) : (
                                                                <ul className="mb-0 pl-3">
                                                                    {showdefault.permissionIDs.map((perm) => (
                                                                        <li key={perm.id}>{perm.title}</li>
                                                                    ))}
                                                                </ul>
                                                            )
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <th>{t("list_heading_created_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault.createdAt
                                                            ? formateDate(showdefault.createdAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_modified_date")}</th>
                                                    <td>
                                                        {showdefault && showdefault?.updatedAt
                                                            ? formateDate(showdefault.updatedAt)
                                                            : "N/A"}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>

                                        <div className="mt-5">
                                            <button
                                                className="btn ripple btn-dark"
                                                type="button"
                                                onClick={() => navigate(-1)}
                                            >
                                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                                {t("btn_back")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RoleView;
